import React, { useEffect, useLayoutEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import algorandIcon from "../../assets/ms-new-images/Algorand-logo.svg";
import IconMetaMask from "../../assets/img/icon-metamask.svg";
import { FButton, FDialog, FTypo } from "ferrum-design-system";
import {
  useAlgoSignerWalletConnector,
  useKeplrWalletConnector,
  useWalletConnector,
} from "foundry";
import { networkImages } from "../networkImages";
import {
  TruncateWithoutRounding,
  getFRMBalance,
  getFormattedLongWalletAddress,
  getFormattedWalletLastAddress,
} from "../global.utils";
import { getFormattedBalance } from "../../utils/global.utils";
import { IoExitOutline } from "react-icons/io5";
import chnageAddressIcon from "../../assets/ms-new-images/icons/ms-change-icon.png";
import disconnectWalletsIcon from "../../assets/ms-new-images/icons/disconnected-wallets-icon.png";
import { ConnectWalletDialogMultiSwap } from "./ConnectWalletDialogMultiSwap";
import { addClassToBodyTag } from "../helperFunctions";
import { IS_MULTISWAP, ME_TAG, TOKEN_TAG, TOKEN_TAG_V3 } from "../const.utils";
import toast from "react-hot-toast";
import * as walletAuthenticationActions from "../../components/common/wallet-authentication/redux/walletAuthenticationActions";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import Web3 from "web3";

export const ConnectedWalletAccount = ({
  show,
  onHide,
  metaMaskClickEvent,
  zerionClickEvent,
  walletConnectClickEvent,
  algorandWalletClickEvent,
  selectAlgorandWalletAddress,
  keplrWalletClickEvent,
}: any) => {
  const dispatch = useDispatch();
  const [showLoadingDialog, setShowLoadingDialog] = useState(false);
  const [showAddressesDialog, setShowAddressesDialog] = useState(false);
  const [showConnectWalletDlg, setShowConnectWalletDlg] = useState(false);
  const [frmBalance, setFrmBalance] = useState("0");
  const {
    currentWallet,
    isConnected,
    isConnecting,
    walletAddress,
    walletBalance,
    web3Sdk,
    currentNetworkChainId,
  } = useWalletConnector();
  const { isAlgoConnected, walletAddresses, connectedAlgorandWalletAddress } =
    useAlgoSignerWalletConnector();
  const { isKeplrConnected, keplrWalletBalance, connectedKeplrWalletAddress } =
    useKeplrWalletConnector();

  const { connectedNetwork, selectedWallet, tokenData, theme } = useSelector(
    (state: RootState) => ({
      ...state.config,
      ...state.networks,
      ...state.wallets,
      ...state.crucible,
    })
  );

  // useEffect(() => {
  //   setShowLoadingDialog(false);
  // }, [showLoadingDialog]);

  useEffect(() => {
    if (show) {
      if (!isConnected && !isAlgoConnected && !isKeplrConnected) {
        setShowLoadingDialog(true);
        addClassToBodyTag(true);
        setTimeout(() => {
          onHide();
          setShowLoadingDialog(false);
          addClassToBodyTag(false);
        }, 1500);
      }
    }
    // eslint-disable-next-line
  }, [isConnected, isAlgoConnected, isKeplrConnected]);

  const handleDisconnetAllWallets = () => {
    localStorage.removeItem(TOKEN_TAG);
    localStorage.removeItem(TOKEN_TAG_V3);
    localStorage.removeItem(ME_TAG);
    dispatch(walletAuthenticationActions.removeSessions());
    if (
      isConnected &&
      currentWallet === "MetaMask" &&
      isAlgoConnected &&
      isKeplrConnected
    ) {
      metaMaskClickEvent();
      algorandWalletClickEvent();
      keplrWalletClickEvent();
    } else if (
      isConnected &&
      currentWallet === "MetaMask" &&
      !isAlgoConnected
    ) {
      metaMaskClickEvent();
    } else if (
      isConnected &&
      currentWallet === "WalletConnect" &&
      !isAlgoConnected
    ) {
      walletConnectClickEvent();
    } else if (isConnected && currentWallet === "Zerion") {
      zerionClickEvent();
    } else if (!isConnected && isAlgoConnected) {
      algorandWalletClickEvent();
    } else if (!isConnected && isKeplrConnected) {
      keplrWalletClickEvent();
    }
  };

  const GlobalStyles = createGlobalStyle`
  .accountbody{
    .ms-connected-wallet-account-info{
      background:${theme?.colors?.background}!important;
    }
    .balance{
      color:${theme?.colors?.primaryLight}!important;
    }
    .white-color{
      color:${theme?.colors?.primaryLight}!important;
    }
    .primary-color{
      color:${theme?.colors?.primary}!important;
    }
    .ms-connected-wallets label{
      color:${theme?.colors?.primaryLight}!important;
    }
    .ms-connected-wallets{
      .ms-connected-wallet-detail{
        background:${theme?.colors?.background}!important;
      }
      .ms-connected-wallet-detail{
        .ms-wallet-address{
          color:${theme?.colors?.primaryLight}!important;
        }
        }
      }
  }
  .f-dialog-connected-wallets {
    .f-dialog {
      background-image: url(${theme?.dialogs?.crucibleModalAccount}) !important;
    }
  }
  `;

  useEffect(() => {
    if (
      connectedNetwork &&
      web3Sdk &&
      walletAddress &&
      currentNetworkChainId &&
      show
    ) {
      const web3 = new Web3(connectedNetwork?.rpcUrl);
      if (currentNetworkChainId === 56) {
        getFRMBalance(
          web3,
          walletAddress,
          "0xA719b8aB7EA7AF0DDb4358719a34631bb79d15Dc",
          setFrmBalance
        );
      } else if (currentNetworkChainId === 42161) {
        getFRMBalance(
          web3,
          walletAddress,
          "0x9f6AbbF0Ba6B5bfa27f4deb6597CC6Ec20573FDA",
          setFrmBalance
        );
      }
    }
    // eslint-disable-next-line
  }, [web3Sdk, walletAddress, currentNetworkChainId, show]);

  if (IS_MULTISWAP) {
    return (
      <>
        {/* {show ? ( */}
        <FDialog
          className="ms-connected-account-title"
          show={show}
          size={"large"}
          onHide={onHide}
          title="Account"
          variant={"connected-wallets"}
        >
          <>
            <div className="accountbody">
              <div className="ms-connected-wallet-account-info">
                <div className="ms-connected-wallet-account-balance">
                  <p className="balance">
                    <span className="ms-connected-wallet-balance">Balance</span>{" "}
                    {getFormattedWalletLastAddress(
                      isConnected
                        ? walletAddress
                        : isKeplrConnected
                        ? connectedKeplrWalletAddress
                        : isAlgoConnected
                        ? connectedAlgorandWalletAddress
                        : ""
                    )}
                  </p>
                  <p className="amount">
                    <FTypo
                      size={20}
                      weight={400}
                      color={theme?.colors?.primaryLight}
                    >
                      {TruncateWithoutRounding(
                        isConnected
                          ? getFormattedBalance(walletBalance)
                          : isKeplrConnected
                          ? keplrWalletBalance
                          : "",
                        5
                      )}
                      <span className="f-pl--5 custom-font-size-15 primary-color">
                        {connectedNetwork &&
                          connectedNetwork?.networkCurrencySymbol}
                      </span>
                    </FTypo>
                    {/* $9198.213 <span>USD</span> */}
                  </p>
                </div>
                <div className="ms-connected-wallet-account-amount d-flex">
                  <p className="d-flex">
                    <img
                      src={
                        tokenData["FRMBSC"]?.logo
                          ? tokenData["FRMBSC"]?.logo
                          : "https://bscscan.com/token/images/ferrumnetwork_32.png?=v1"
                      }
                      height="22px"
                      width="22px"
                      style={{ marginRight: "3px" }}
                      alt=""
                    />
                    <span className="f-pl--2 custom-font-size-13 font-size-13">
                      {TruncateWithoutRounding(frmBalance, 5)}{" "}
                      <span className="primary-color">
                        {tokenData["FRMBSC"]?.symbol
                          ? tokenData["FRMBSC"]?.symbol
                          : "FRM"}
                      </span>
                    </span>
                  </p>
                  {/* <p className="d-flex f-m-1">
                    <img
                      src={
                        tokenData["FRMxBSC"]?.logo
                          ? tokenData["FRMxBSC"]?.logo
                          : "https://s2.coinmarketcap.com/static/img/coins/64x64/7631.png"
                      }
                      height="22px"
                      width="22px"F
                      alt=""
                      style={{ marginRight: "3px" }}
                    />
                    <span className="primary-color f-pl--2 custom-font-size-13">
                      {tokenData["FRMxBSC"]
                        ? TruncateWithoutRounding(
                            tokenData["FRMxBSC"]?.balance,
                            3
                          )
                        : "0"}{" "}
                      <span className="white-color">
                        {tokenData["FRMxBSC"]?.symbol
                          ? tokenData["FRMxBSC"]?.symbol
                          : "FRMx"}
                      </span>
                    </span>
                  </p> */}
                </div>
              </div>
              <div
                className={`ms-connected-wallets ${
                  isConnected && !isAlgoConnected
                    ? "show-bottom-space-metamask"
                    : !isConnected && isAlgoConnected
                    ? "show-bottom-space-algo"
                    : ""
                }`}
              >
                <label>Wallets</label>
                {isConnected && currentWallet === "MetaMask" && (
                  <div className="ms-connected-wallet-detail">
                    <div className="wallet-network-logo">
                      {connectedNetwork ? (
                        <img
                          src={connectedNetwork?.logo}
                          height="25px"
                          width="25px"
                          alt=""
                          className="ms-wallet-logos"
                        />
                      ) : null}
                      {selectedWallet || IconMetaMask ? (
                        <img
                          src={selectedWallet?.logo || IconMetaMask}
                          height="25px"
                          width="25px"
                          alt=""
                          className="ms-wallet-logos"
                        />
                      ) : null}
                    </div>
                    <span className="ms-wallet-address">{walletAddress}</span>
                    {/* <FButton
                      title={"DISCONNECT"}
                      onClick={() => {
                        metaMaskClickEvent();
                        setShowLoadingDialog(true);
                        dispatch(walletAuthenticationActions.removeSessions());
                      }}
                      className="ms-connected-wallet-button-disconnect"
                      prefix={<IoExitOutline />}
                    /> */}
                  </div>
                )}
                {isConnected && currentWallet === "WalletConnect" && (
                  <div className="ms-connected-wallet-detail">
                    <div>
                      <img
                        src={connectedNetwork?.logo}
                        height="25px"
                        width="25px"
                        alt=""
                        className="ms-wallet-logos"
                      />
                      <img
                        src={selectedWallet?.logo}
                        height="25px"
                        width="25px"
                        alt=""
                        className="ms-wallet-logos"
                      />
                    </div>
                    <span className="ms-wallet-address">
                      {getFormattedLongWalletAddress(walletAddress)}
                    </span>
                    <FButton
                      title={"Disonnect"}
                      onClick={() => {
                        walletConnectClickEvent();
                        setShowLoadingDialog(true);
                        dispatch(walletAuthenticationActions.removeSessions());
                      }}
                      className="ms-connected-wallet-button-disconnect"
                      prefix={<IoExitOutline />}
                    />
                  </div>
                )}
                {isKeplrConnected && (
                  <div className="ms-connected-wallet-detail">
                    <div>
                      <img
                        src={connectedNetwork?.logo}
                        height="25px"
                        width="25px"
                        alt=""
                        className="ms-wallet-logos"
                      />
                      <img
                        src={selectedWallet?.logo}
                        height="25px"
                        width="25px"
                        alt=""
                        className="ms-wallet-logos"
                      />
                    </div>
                    <span className="ms-wallet-address">
                      {getFormattedLongWalletAddress(
                        isConnected
                          ? walletAddress
                          : isKeplrConnected
                          ? connectedKeplrWalletAddress
                          : isAlgoConnected
                          ? connectedAlgorandWalletAddress
                          : ""
                      )}
                    </span>
                    <FButton
                      title={"Disonnect"}
                      onClick={() => {
                        keplrWalletClickEvent();
                        dispatch(walletAuthenticationActions.removeSessions());
                      }}
                      className="ms-connected-wallet-button-disconnect"
                      prefix={<IoExitOutline />}
                    />
                  </div>
                )}
                {isAlgoConnected && (
                  <div className="ms-connected-wallet-detail f-mt--7">
                    <div>
                      <img
                        src={networkImages["ALGORAND"]}
                        height="25px"
                        width="25px"
                        alt=""
                        className="ms-wallet-logos"
                      />
                      <img
                        src={algorandIcon}
                        height="25px"
                        width="25px"
                        alt=""
                        className="ms-wallet-logos"
                      />
                    </div>
                    <span className="ms-wallet-address">
                      {getFormattedLongWalletAddress(
                        connectedAlgorandWalletAddress
                      )}
                    </span>
                    <img
                      src={chnageAddressIcon}
                      height="20px"
                      width="20px"
                      alt=""
                      className="ms-wallet-logos cursor-pointer"
                      onClick={() => {
                        addClassToBodyTag(true);
                        setShowAddressesDialog(true);
                      }}
                    />
                    <FButton
                      title={"Disonnect"}
                      onClick={() => {
                        algorandWalletClickEvent();
                        dispatch(walletAuthenticationActions.removeSessions());
                      }}
                      className="ms-connected-wallet-button-disconnect"
                      prefix={<IoExitOutline />}
                    />
                  </div>
                )}
                {!isConnected && !isAlgoConnected && !isKeplrConnected && (
                  <div className="ms-no-connected-wallets">
                    No Connected Wallets
                  </div>
                )}
              </div>
              <div className="ms-connected-wallet-buttons-wrapper ">
                {/* <div className="btn-connect">
                  <FButton
                    title={"Connect Wallet"}
                    onClick={() => {
                      toast.success("Coming Soon");
                      // addClassToBodyTag(true);
                      // setShowConnectWalletDlg(true);
                    }}
                    className="ms-connected-wallet-button-connect"
                  />
                </div> */}
                {isConnected ? (
                  <div className="btn-disconnect">
                    <FButton
                      title={"DISCONNECT"}
                      onClick={() => handleDisconnetAllWallets()}
                      className="ms-connected-wallet-button-disconnect"
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </>
        </FDialog>
        {/* ) : null} */}

        {showLoadingDialog ? (
          <FDialog
            show={showLoadingDialog}
            size={"large"}
            onHide={() => {
              addClassToBodyTag(false);
              setShowLoadingDialog(false);
            }}
            variant={"loading-dialog"}
            title=""
          >
            <>
              <div className="ms-loading-dialog-info f-mt-2">
                <div className="ms-loading-dialog-icon mb-2">
                  <img src={disconnectWalletsIcon} alt="" />
                </div>
                <div className="ms-loading-dialog-text f-mt-1">
                  Thank you for using MultiSwap.
                </div>
              </div>
            </>
          </FDialog>
        ) : null}

        {showAddressesDialog ? (
          <FDialog
            show={showAddressesDialog}
            size={"large"}
            onHide={() => {
              addClassToBodyTag(false);
              setShowAddressesDialog(false);
            }}
            variant={"algorand-addresses"}
            title="Select Account"
          >
            <>
              <div className="ms-select-algorand-account-addresses-wrapper">
                {isAlgoConnected && walletAddresses && walletAddresses.length
                  ? walletAddresses.map((item: any) => {
                      return (
                        <div className="ms-select-algorand-account-addresses f-mb--5 d-flex jc jc-space-between">
                          <div className="d-flex">
                            <img
                              src={networkImages["ALGORAND"]}
                              height="25px"
                              width="25px"
                              alt=""
                            />
                            <img
                              src={algorandIcon}
                              height="25px"
                              width="25px"
                              alt=""
                            />
                          </div>
                          <span>
                            {getFormattedLongWalletAddress(item.address)}
                          </span>
                          <FButton
                            title={"SELECT ACCOUNT"}
                            onClick={() => {
                              selectAlgorandWalletAddress(item.address);
                              setShowAddressesDialog(false);
                            }}
                            className="ms-select-algorand-account-addresses-button"
                          />
                        </div>
                      );
                    })
                  : null}
              </div>
            </>
          </FDialog>
        ) : null}
        <ConnectWalletDialogMultiSwap
          show={showConnectWalletDlg}
          onHide={() => {
            addClassToBodyTag(false);
            setShowConnectWalletDlg(false);
          }}
          metaMaskClickEvent={metaMaskClickEvent}
          zerionClickEvent={zerionClickEvent}
          walletConnectClickEvent={walletConnectClickEvent}
          algorandWalletClickEvent={algorandWalletClickEvent}
          selectAlgorandWalletAddress={selectAlgorandWalletAddress}
        />
      </>
    );
  } else {
    return (
      <>
        <ThemeProvider theme={theme ? theme : ""}>
          {show ? (
            <FDialog
              show={show}
              size={"large"}
              onHide={onHide}
              title="Account"
              variant={"connected-wallets"}
            >
              <>
                <div className="accountbody">
                  <div className="ms-connected-wallet-account-info">
                    <div className="ms-connected-wallet-account-balance">
                      <p className="balance">
                        <span className="ms-connected-wallet-balance">
                          Balance
                        </span>{" "}
                        {getFormattedWalletLastAddress(
                          isConnected
                            ? walletAddress
                            : isKeplrConnected
                            ? connectedKeplrWalletAddress
                            : isAlgoConnected
                            ? connectedAlgorandWalletAddress
                            : ""
                        )}
                      </p>
                      <p className="amount">
                        <FTypo
                          size={20}
                          weight={400}
                          color={theme?.colors?.primaryLight}
                        >
                          {TruncateWithoutRounding(
                            isConnected
                              ? getFormattedBalance(walletBalance)
                              : isKeplrConnected
                              ? keplrWalletBalance
                              : "",
                            5
                          )}
                          <span className="f-pl--5 custom-font-size-15 primary-color">
                            {connectedNetwork &&
                              connectedNetwork?.networkCurrencySymbol}
                          </span>
                        </FTypo>
                        {/* $9198.213 <span>USD</span> */}
                      </p>
                    </div>
                    <div className="ms-connected-wallet-account-amount d-flex">
                      <p className="d-flex">
                        <img
                          src={
                            tokenData["FRMBSC"]?.logo
                              ? tokenData["FRMBSC"]?.logo
                              : "https://bscscan.com/token/images/ferrumnetwork_32.png?=v1"
                          }
                          height="22px"
                          width="22px"
                          style={{ marginRight: "3px" }}
                          alt=""
                        />
                        <span className="f-pl--2 custom-font-size-13 font-size-13">
                          {TruncateWithoutRounding(frmBalance, 5)}{" "}
                          <span className="primary-color">
                            {tokenData["FRMBSC"]?.symbol
                              ? tokenData["FRMBSC"]?.symbol
                              : "FRM"}
                          </span>
                        </span>
                      </p>
                      {/* <p className="d-flex f-m-1">
                    <img
                      src={
                        tokenData["FRMxBSC"]?.logo
                          ? tokenData["FRMxBSC"]?.logo
                          : "https://s2.coinmarketcap.com/static/img/coins/64x64/7631.png"
                      }
                      height="22px"
                      width="22px"F
                      alt=""
                      style={{ marginRight: "3px" }}
                    />
                    <span className="primary-color f-pl--2 custom-font-size-13">
                      {tokenData["FRMxBSC"]
                        ? TruncateWithoutRounding(
                            tokenData["FRMxBSC"]?.balance,
                            3
                          )
                        : "0"}{" "}
                      <span className="white-color">
                        {tokenData["FRMxBSC"]?.symbol
                          ? tokenData["FRMxBSC"]?.symbol
                          : "FRMx"}
                      </span>
                    </span>
                  </p> */}
                    </div>
                  </div>
                  <div
                    className={`ms-connected-wallets ${
                      isConnected && !isAlgoConnected
                        ? "show-bottom-space-metamask"
                        : !isConnected && isAlgoConnected
                        ? "show-bottom-space-algo"
                        : ""
                    }`}
                  >
                    <label>Wallets</label>
                    {isConnected && currentWallet === "MetaMask" && (
                      <div className="ms-connected-wallet-detail">
                        <div>
                          <img
                            src={connectedNetwork?.logo}
                            height="25px"
                            width="25px"
                            alt=""
                            className="ms-wallet-logos"
                          />
                          <img
                            src={selectedWallet?.logo}
                            height="25px"
                            width="25px"
                            alt=""
                            className="ms-wallet-logos"
                          />
                        </div>
                        <span className="ms-wallet-address">
                          {walletAddress}
                        </span>
                        {/* <FButton
                        title={"Disonnect"}
                        onClick={() => {
                          metaMaskClickEvent();
                          dispatch(
                            walletAuthenticationActions.removeSessions()
                          );
                        }}
                        className="ms-connected-wallet-button-disconnect"
                        prefix={<IoExitOutline />}
                      /> */}
                      </div>
                    )}
                    {isKeplrConnected && (
                      <div className="ms-connected-wallet-detail">
                        <div>
                          <img
                            src={connectedNetwork?.logo}
                            height="25px"
                            width="25px"
                            alt=""
                            className="ms-wallet-logos"
                          />
                          <img
                            src={selectedWallet?.logo}
                            height="25px"
                            width="25px"
                            alt=""
                            className="ms-wallet-logos"
                          />
                        </div>
                        <span className="ms-wallet-address">
                          {getFormattedLongWalletAddress(
                            isConnected
                              ? walletAddress
                              : isKeplrConnected
                              ? connectedKeplrWalletAddress
                              : isAlgoConnected
                              ? connectedAlgorandWalletAddress
                              : ""
                          )}
                        </span>
                        {/* <FButton
                        title={"Disonnect"}
                        onClick={() => {
                          keplrWalletClickEvent();
                          dispatch(
                            walletAuthenticationActions.removeSessions()
                          );
                        }}
                        className="ms-connected-wallet-button-disconnect"
                        prefix={<IoExitOutline />}
                      /> */}
                      </div>
                    )}
                    {isAlgoConnected && (
                      <div className="ms-connected-wallet-detail f-mt--7">
                        <div>
                          <img
                            src={networkImages["ALGORAND"]}
                            height="25px"
                            width="25px"
                            alt=""
                            className="ms-wallet-logos"
                          />
                          <img
                            src={algorandIcon}
                            height="25px"
                            width="25px"
                            alt=""
                            className="ms-wallet-logos"
                          />
                        </div>
                        <span className="ms-wallet-address">
                          {getFormattedLongWalletAddress(
                            connectedAlgorandWalletAddress
                          )}
                        </span>
                        <img
                          src={chnageAddressIcon}
                          height="20px"
                          width="20px"
                          alt=""
                          className="ms-wallet-logos cursor-pointer"
                          onClick={() => {
                            addClassToBodyTag(true);
                            setShowAddressesDialog(true);
                          }}
                        />
                        {/* <FButton
                        title={"Disonnect"}
                        onClick={() => {
                          algorandWalletClickEvent();
                          dispatch(
                            walletAuthenticationActions.removeSessions()
                          );
                        }}
                        className="ms-connected-wallet-button-disconnect"
                        prefix={<IoExitOutline />}
                      /> */}
                      </div>
                    )}
                    {!isConnected && !isAlgoConnected && !isKeplrConnected && (
                      <div className="ms-no-connected-wallets">
                        No Connected Wallets
                      </div>
                    )}
                  </div>
                  <div className="ms-connected-wallet-buttons-wrapper ">
                    {/* <div className="btn-connect">
                  <FButton
                    title={"Connect Wallet"}
                    onClick={() => {
                      toast.success("Coming Soon");
                      // addClassToBodyTag(true);
                      // setShowConnectWalletDlg(true);
                    }}
                    className="ms-connected-wallet-button-connect"
                  />
                </div> */}
                    <div className="btn-disconnect">
                      <FButton
                        title={"Disonnect"}
                        onClick={() => handleDisconnetAllWallets()}
                        className="ms-connected-wallet-button-disconnect"
                      />
                    </div>
                  </div>
                </div>
              </>
            </FDialog>
          ) : null}

          {/* <FDialog
          show={showLoadingDialog}
          size={"large"}
          onHide={() => {
            addClassToBodyTag(false);
            setShowLoadingDialog(false);
          }}
          variant={"loading-dialog"}
          title=""
        >
          <>
            <div className="ms-loading-dialog-info f-mt-2">
              <div className="ms-loading-dialog-icon mb-2">
                <img src={disconnectWalletsIcon} alt="" />
              </div>
              <div className="ms-loading-dialog-text f-mt-1">
                Thank you {IS_MULTISWAP ? "for using MultiSwap." : ""}
              </div>
            </div>
          </>
        </FDialog> */}
          {showAddressesDialog ? (
            <FDialog
              show={showAddressesDialog}
              size={"large"}
              onHide={() => {
                addClassToBodyTag(false);
                setShowAddressesDialog(false);
              }}
              variant={"algorand-addresses"}
              title="Select Account"
            >
              <>
                <div className="ms-select-algorand-account-addresses-wrapper">
                  {isAlgoConnected && walletAddresses && walletAddresses.length
                    ? walletAddresses.map((item: any) => {
                        return (
                          <div className="ms-select-algorand-account-addresses f-mb--5 d-flex jc jc-space-between">
                            <div className="d-flex">
                              <img
                                src={networkImages["ALGORAND"]}
                                height="25px"
                                width="25px"
                                alt=""
                              />
                              <img
                                src={algorandIcon}
                                height="25px"
                                width="25px"
                                alt=""
                              />
                            </div>
                            <span>
                              {getFormattedLongWalletAddress(item.address)}
                            </span>
                            <FButton
                              title={"SELECT ACCOUNT"}
                              onClick={() => {
                                selectAlgorandWalletAddress(item.address);
                                setShowAddressesDialog(false);
                              }}
                              className="ms-select-algorand-account-addresses-button"
                            />
                          </div>
                        );
                      })
                    : null}
                </div>
              </>
            </FDialog>
          ) : null}
          {showConnectWalletDlg && (
            <ConnectWalletDialogMultiSwap
              show={showConnectWalletDlg}
              onHide={() => {
                addClassToBodyTag(false);
                setShowConnectWalletDlg(false);
              }}
              metaMaskClickEvent={metaMaskClickEvent}
              zerionClickEvent={zerionClickEvent}
              walletConnectClickEvent={walletConnectClickEvent}
              algorandWalletClickEvent={algorandWalletClickEvent}
              selectAlgorandWalletAddress={selectAlgorandWalletAddress}
            />
          )}
          <GlobalStyles />
        </ThemeProvider>
      </>
    );
  }
};
